import { isEmpty } from 'lodash'

import cnpjValidate from 'helpers/validates/cnpj'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const cnpj = {
  name: 'cnpj',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CNPJ inválido') {
    return this.test(
      'cnpj',
      message,
      (value) => isEmpty(value) || cnpjValidate.isValid(value),
    )
  },
}

export default cnpj
